import { JourneyPlace } from '../../lib/types/models/journey-place/journey-place'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getJourneyPlace(id: number) {
  return restApiClient.url(constructApiUrl(API.journeyPlaces.get.url, { id })).get<JourneyPlace>()
}
